/**
 * Helpers for route meta() functions.
 *
 * meta() runs at SSR time without access to React context, so the active brand
 * must be pulled out of the matched route loaders. The root loader exposes the
 * resolved brand (see app/lib/brand.ts); these helpers wrap that lookup so
 * meta() implementations can call `i18n.t(key, { brandName })` without
 * repeating the boilerplate.
 */
import type { Brand } from "~/lib/brand";
import { BRAND_DISPLAY_NAMES } from "~/lib/brand";

interface RootData {
  brand?: Brand;
}

// MetaArgs from RR7 typegen exposes `matches` as a heterogeneous tuple whose
// entries may be `undefined`. Accept that shape directly rather than forcing
// every caller to narrow first.
type MetaMatchLike = { id: string; data?: unknown } | undefined;

export function getBrandName(matches: ReadonlyArray<MetaMatchLike>): string {
  const root = matches.find((m): m is { id: string; data?: unknown } =>
    m?.id === "root",
  );
  const brand = (root?.data as RootData | undefined)?.brand ?? "foodpanda";
  return BRAND_DISPLAY_NAMES[brand];
}
